import React, { useState } from 'react';
import './ReasonModal.css';

const ReasonModal = ({ isOpen, onClose, onConfirm, action, pluginName }) => {
  const [reason, setReason] = useState('');

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (reason.trim()) {
      onConfirm(reason.trim());
      setReason('');
    }
  };

  const handleCancel = () => {
    setReason('');
    onClose();
  };

  const getActionLabel = () => {
    switch (action) {
      case 'activate':
        return 'Activate';
      case 'deactivate':
        return 'Deactivate';
      case 'update':
        return 'Update';
      case 'enable-auto-update':
        return 'Enable Auto-update';
      default:
        return 'Action';
    }
  };

  const getPlaceholder = () => {
    switch (action) {
      case 'activate':
        return 'e.g., Need this plugin for new feature';
      case 'deactivate':
        return 'e.g., I don\'t need that plugin for now';
      case 'update':
        return 'e.g., Update to get latest security patches';
      case 'enable-auto-update':
        return 'e.g., Keep plugin updated automatically for security and new features';
      default:
        return 'Enter reason...';
    }
  };

  return (
    <div className="reason-modal-overlay" onClick={handleCancel}>
      <div className="reason-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="reason-modal-header">
          <h3>Reason for {getActionLabel()}</h3>
          <button className="reason-modal-close" onClick={handleCancel}>×</button>
        </div>
        <div className="reason-modal-body">
          <p className="reason-modal-plugin-name">
            <strong>Plugin:</strong> {pluginName || 'Unknown'}
          </p>
          <form onSubmit={handleSubmit}>
            <label htmlFor="reason-input">
              Reason for {action.toLowerCase()}:
            </label>
            <textarea
              id="reason-input"
              className="reason-input"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder={getPlaceholder()}
              rows="4"
              required
              autoFocus
            />
            <div className="reason-modal-actions">
              <button type="button" className="reason-modal-cancel" onClick={handleCancel}>
                Cancel
              </button>
              <button type="submit" className="reason-modal-confirm" disabled={!reason.trim()}>
                {getActionLabel()}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ReasonModal;

